import React, { memo, CSSProperties, FC } from "react";
import Typography from "@mui/material/Typography";
import Choices from "../../Choices";
import SlidingScreenAccordian from "../SlidingScreen/SlidingScreenAccordian";
import { Image, Transformation } from "cloudinary-react";
import SliderScreenPocketAccordian from "../ScreenPocket/SliderScreenPocketAccordian";
import ScreenTypeAccordian from "../ScreenType/ScreenTypeAccordian";
import ReusableAccordian from "../../ReusableAccordion";
import { screenColors, screenLayoutImages, ScreenObj } from "./defaults";
import {
  comboScreenLayout,
  shadeColors,
  // shadeLayout,
} from "../../../initialValues/screens";
import { RowLayout, ColLayout } from "../../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useSliderScreenSelector from "./useSliderScreenSelector";
import { addScrollElements } from "../../AccordionWrapper/AccordianWrapper";

const ColLayoutSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  padding: theme.spacing(1, 2),
}));

const StyledSpan = styled("span")({
  color: "red",
  fontSize: 22,
});

interface ScreenLayoutChoicesProps {
  layout: ScreenObj[];
  handleClick: (pdfLabel: string, disabled: boolean, layoutType: string) => void;
  screenLayout: string;
  layoutType: string;
}

export type ScreenTypeObj = {
  id: number;
  type: string;
  label: string;
};

const ScreenLayoutChoices: FC<ScreenLayoutChoicesProps> = ({
  layout,
  handleClick,
  screenLayout,
  layoutType
}): any => {
  return layout.map((state) => (
    <div
      key={state.id}
      onClick={() => handleClick(state.pdfLabel || "", state.disabled || false, layoutType)}
    >
      <Choices
        label={state.label}
        variant={state.pdfLabel === screenLayout ? "filled" : "outlined"}
        checkMark={state.pdfLabel === screenLayout}
        disabled={state.disabled || false}
      />
    </div>
  ));
};

function SliderScreenAccordian() {
  const {
    showSliderScreens,
    isSlimline,
    displayedImage,
    screenOptions,
    handleAddScreenClick,
    handleLayoutClick,
    handleScreenColorClick,
    handleShadeColorClick,
    showSlidingScreen,
    hideScreenPocket,
    screenChoices,
    chipArrangement2,
    helper,
    helper2,
    hasShade,
    chosenConfig,
    screenTypeOptions,
    screenTypeChoice,
    screenVal,
    screenLayout,
    shadeMeshColor,
    screenColor,
    isPocketing,
  } = useSliderScreenSelector();

  if (!chosenConfig) return null;

  return (
    <>
      {chosenConfig && (
        <>
          <ScreenTypeAccordian screenTypeOptions={screenTypeOptions} />
          {showSliderScreens ? (
            <>
              {addScrollElements([
                "Add Screen",
                "Screen Layout",
                "Screen Extrusion Color",
                "Shade Layout",
                "Shade Mesh Color",
                "Shade Extrusion Color",
                "Combo Layout",
                "Combo Mesh Color",
                "Combo Extrusion Color",
                "Centor Screen",
                "Brio Screen"
              ])}

              {showSlidingScreen ? (
                <SlidingScreenAccordian />
              ) : (
                <>
                  <ReusableAccordian
                    accordionName="screen"
                    heading={`${
                      screenTypeChoice === "Centor Flat Screen/Shade"
                        ? "Centor"
                        : "Brio"
                    } Screen`}
                    secondaryHeading="Select Screen Option"
                  >
                    <ColLayout>
                      {isSlimline &&
                        !hideScreenPocket &&
                        screenTypeChoice !== "Centor Flat Screen/Shade" && (
                          <Typography variant="subtitle1">
                            *Pocketing Screen recommended for Slimline
                          </Typography>
                        )}

                      <Typography variant="subtitle1">
                        *upcharge applies to all screens/shades
                      </Typography>

                      <RowLayout>
                        {screenChoices.map((state, idx) => (
                          <div
                            key={idx}
                            onClick={() => handleAddScreenClick(state.label)}
                          >
                            <Choices
                              label={state.label}
                              variant={
                                state.label === screenVal
                                  ? "filled"
                                  : "outlined"
                              }
                              checkMark={state.label === screenVal}
                            />
                          </div>
                        ))}
                      </RowLayout>

                      <RowLayout>
                        {(screenVal === "Add Screen" ||
                          screenVal === "Add Combo Screen/Shade" ||
                          screenVal === "Add Shade") && (
                          <ColLayoutSpacing>
                            <Typography variant="subtitle1">
                              {screenVal === "Add Combo Screen/Shade" &&
                                "Combo "}
                              {screenVal === "Add Screen" && "Screen "}
                              {screenVal === "Add Shade" && "Shade "} Layout
                              <StyledSpan>*</StyledSpan>
                            </Typography>
                            <RowLayout>
                              {screenVal === "Add Shade" ? (
                                <ScreenLayoutChoices
                                  layout={screenOptions?.shadeLayout || []}
                                  handleClick={handleLayoutClick}
                                  screenLayout={screenLayout || ""}
                                  layoutType="Shade Layout"
                                />
                              ) : screenVal === "Add Combo Screen/Shade" ? (
                                <>
                                  {comboScreenLayout.map((state) => (
                                    <div
                                      key={state.id}
                                      onClick={() =>
                                        handleLayoutClick(
                                          state.pdfLabel,
                                          state.disabled || false,
                                          "Combo Layout"
                                        )
                                      }
                                    >
                                      <Choices
                                        label={state.label}
                                        variant={
                                          (state.label.includes(
                                            "Left Screen",
                                          ) &&
                                            screenLayout?.includes(
                                              "Left Screen",
                                            )) ||
                                          (state.label.includes(
                                            "Right Screen",
                                          ) &&
                                            screenLayout?.includes(
                                              "Right Screen",
                                            ))
                                            ? "filled"
                                            : "outlined"
                                        }
                                        checkMark={
                                          (state.label.includes(
                                            "Left Screen",
                                          ) &&
                                            screenLayout?.includes(
                                              "Left Screen",
                                            )) ||
                                          (state.label.includes(
                                            "Right Screen",
                                          ) &&
                                            screenLayout?.includes(
                                              "Right Screen",
                                            ))
                                            ? true
                                            : false
                                        }
                                      />
                                    </div>
                                  ))}
                                </>
                              ) : (
                                <ScreenLayoutChoices
                                  layout={screenOptions?.layout || []}
                                  handleClick={handleLayoutClick}
                                  screenLayout={screenLayout || ""}
                                  layoutType="Screen Layout"
                                />
                              )}
                            </RowLayout>
                          </ColLayoutSpacing>
                        )}

                        {hasShade && (
                          <div
                            style={
                              screenVal === "Add Double Shade"
                                ? ({
                                    ...chipArrangement2,
                                    ...helper2,
                                  } as CSSProperties)
                                : ({
                                    ...chipArrangement2,
                                    ...helper,
                                  } as CSSProperties)
                            }
                          >
                            <Typography variant="subtitle1">
                              {/* {screenVal === "Add Combo Screen/Shade" &&
                                "Combo "}
                              {(screenVal === "Add Shade" ||
                                screenVal === "Add Double Shade") &&
                                "Shade "}{" "} */}
                              Shade Mesh Color
                              <StyledSpan>*</StyledSpan>
                            </Typography>

                            <RowLayout>
                              {shadeColors.map((state) => (
                                <div
                                  key={state.id}
                                  onClick={() =>
                                    handleShadeColorClick(
                                      state.label,
                                      'Shade Mesh Color'
                                      // `${screenVal === "Add Combo Screen/Shade" ? "Combo" : ""}${screenVal === "Add Shade" || screenVal === "Add Double Shade" ? "Shade" : ""} Mesh Color`,
                                    )
                                  }
                                >
                                  <Choices
                                    label={state.label}
                                    variant={
                                      state.label === shadeMeshColor
                                        ? "filled"
                                        : "outlined"
                                    }
                                    checkMark={state.label === shadeMeshColor}
                                  />
                                </div>
                              ))}
                            </RowLayout>
                          </div>
                        )}

                        <div
                          style={
                            screenVal === "Add Screen" ||
                            screenVal === "Add Combo Screen/Shade" ||
                            screenVal === "Add Shade" ||
                            screenVal === "Add Double Shade"
                              ? ({
                                  ...chipArrangement2,
                                  ...helper,
                                } as CSSProperties)
                              : (chipArrangement2 as CSSProperties)
                          }
                        >
                          <Typography variant="subtitle1">
                            {screenVal === "Add Combo Screen/Shade" && "Combo "}
                            {(screenVal === "Add Screen" ||
                              screenVal === "Add Double Screen") &&
                              "Screen "}
                            {(screenVal === "Add Shade" ||
                              screenVal === "Add Double Shade") &&
                              "Shade "}{" "}
                            Extrusion Color
                            {screenVal && <StyledSpan>*</StyledSpan>}
                          </Typography>
                          <RowLayout>
                            {screenColors.map((state) => (
                              <div
                                key={state.id}
                                onClick={() =>
                                  handleScreenColorClick(
                                    state.label,
                                    `${screenVal === "Add Combo Screen/Shade" ? "Combo" : ""}${screenVal === "Add Screen" || screenVal === "Add Double Screen" ? "Screen" : ""}${screenVal === "Add Shade" || screenVal === "Add Double Shade" ? "Shade" : ""} Extrusion Color`,
                                  )
                                }
                              >
                                <Choices
                                  label={state.label}
                                  variant={
                                    state.label === screenColor
                                      ? "filled"
                                      : "outlined"
                                  }
                                  checkMark={state.label === screenColor}
                                />
                              </div>
                            ))}
                          </RowLayout>
                        </div>
                      </RowLayout>

                      {displayedImage &&
                        screenLayoutImages
                          .filter((image) => image.label === displayedImage)
                          .map((imageShown) => (
                            <RowLayout key={imageShown.label}>
                              <ColLayout
                                style={{
                                  marginRight: 40,
                                  marginTop: 10,
                                  marginBottom: 5,
                                }}
                              >
                                <Image
                                  cloudName="ag-millworks"
                                  secure="true"
                                  publicId={imageShown.img}
                                />
                                <Typography
                                  style={{ alignSelf: "center" }}
                                  variant="caption"
                                >
                                  *As viewed from exterior
                                </Typography>
                              </ColLayout>

                              {shadeMeshColor && hasShade && (
                                <div style={{ marginTop: -10 }}>
                                  <Image
                                    cloudName="ag-millworks"
                                    secure="true"
                                    publicId={`Shade_Colors/${shadeMeshColor
                                      .split(" ")
                                      .join("_")}_v2`}
                                  >
                                    <Transformation height="220" crop="scale" />
                                  </Image>
                                </div>
                              )}
                            </RowLayout>
                          ))}
                    </ColLayout>
                  </ReusableAccordian>

                  {hideScreenPocket ? null : screenVal && screenOptions ? (
                    <SliderScreenPocketAccordian
                      screenOptions={screenOptions}
                      isPocketing={isPocketing}
                    />
                  ) : null}
                </>
              )}
            </>
          ) : null}
        </>
      )}
    </>
  );
}

export default memo(SliderScreenAccordian);
